function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.5 1.125C5.15117 1.125 1.625 4.65117 1.625 9C1.625 13.3488 5.15117 16.875 9.5 16.875C13.8488 16.875 17.375 13.3488 17.375 9C17.375 4.65117 13.8488 1.125 9.5 1.125ZM9.5 15.5391C5.88945 15.5391 2.96094 12.6105 2.96094 9C2.96094 5.38945 5.88945 2.46094 9.5 2.46094C13.1105 2.46094 16.0391 5.38945 16.0391 9C16.0391 12.6105 13.1105 15.5391 9.5 15.5391Z",
  fill: "#15A9E1"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5709 11.2254L10.0643 9.41307V5.0625C10.0643 4.98516 10.001 4.92188 9.92363 4.92188H9.07812C9.00078 4.92188 8.9375 4.98516 8.9375 5.0625V9.9035C8.9375 9.9492 8.95859 9.99139 8.99551 10.0178L11.9029 12.1377C11.9662 12.1834 12.0541 12.1693 12.0998 12.1078L12.6025 11.4222C12.6482 11.3572 12.6342 11.2693 12.5709 11.2254Z",
  fill: "#15A9E1"
});

var SvgClockCircle = function SvgClockCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClockCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock-circle.7b235743.svg";
export { ForwardRef as ReactComponent };